import type { NavItem } from "../../app/navigation";
import { HonestState } from "../../components/HonestState";
import { PageHeader } from "../../components/PageHeader";

/** Every sidebar destination outside M0 opens an honest state page (decision O10). */
export function HonestPage({ item }: { item: NavItem }) {
  return (
    <div className="space-y-8">
      <PageHeader titleKey={`nav.${item.key}`} />
      <HonestState icon={item.icon} kind={item.honest} descriptionKey={`honest.${item.key}`} />
    </div>
  );
}
